
const Filter = ({ keyword, setKeyword, groupBy, setGroupBy }) => {


    const handleSearchChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleGroupChange = (group) => {
        setGroupBy(group);
    };

    return (



        <div className="filter-paln">
            <div className="search-section-box">
                <form className="app-search ">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Company/Project name..."
                            value={keyword}
                            onChange={handleSearchChange}
                        />
                        <span className="bx bx-search-alt" />
                    </div>
                </form>
            </div>
            <ul>
                <li className={groupBy === 'none' ? 'active' : ''}>
                    <a href="javascript:void(0);" onClick={() => handleGroupChange('none')} style={{ fontSize: '15px' }}>
                        <i className="fa fa-list" /> List
                    </a>
                </li>
                <li className={groupBy === 'company' ? 'active' : ''}>
                    <a href="javascript:void(0);" onClick={() => handleGroupChange('company')} style={{ fontSize: '15px' }}>
                        <i className="fa fa-building" /> By Company
                    </a>
                </li>
                <li className={groupBy === 'shipyard' ? 'active' : ''}>
                    <a href="javascript:void(0);" onClick={() => handleGroupChange('shipyard')} style={{ fontSize: '15px' }}>
                        <i className="bx bxs-ship" /> By Shipyard
                    </a>
                </li>
            </ul>
        </div>



    );
};

export default Filter;
